import React from "react";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Box, Button, Typography } from "@mui/material";

export const TotalBar = ({ total, habilitarButton, onPagar, visibleBotonPagos }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box
        sx={{ borderRight: "3px solid black", paddingRight: 2, marginRight: 2 }}
      >
        <ShoppingCartIcon sx={{ fontSize: 55 }} />
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography variant="h5" fontWeight="bold">
          TOTAL: $
          {Number(total).toLocaleString("es-ES", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </Typography>
      </Box>
      <Box sx={{ float: "right", marginLeft: "auto", mt: -1 }}>
        {visibleBotonPagos&&<Button
          variant="contained"
          disabled={!habilitarButton}
          onClick={habilitarButton && onPagar ? onPagar : undefined}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
            }
          }}
          sx={{
            background: habilitarButton ? "#208E4E" : "#cccccc",
            fontSize: 20,
            width: "180px",
            height: "80px",
            borderRadius: "20px",
            color: habilitarButton ? "#fff" : "#888",
            cursor: habilitarButton ? "pointer" : "not-allowed",
            "&:hover": habilitarButton ? {
              backgroundColor: "#186936",
            } : {
              backgroundColor: "#cccccc",
            },
            "&:disabled": {
              backgroundColor: "#cccccc",
              color: "#888",
            },
          }}
        >
          PAGAR
        </Button>}
      </Box>
    </Box>
  );
};
